import React from 'react';
import {
  arrayOf, bool, shape, string, node
} from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/grid';
import { BulletList } from '../BulletList/BulletList';
import { InfoGuides } from '../InfoGuides/InfoGuides';
import { ProductInfo } from './ProductInfo';
import './mobile-content.scss';

export const MobileContent = (props) => {
  const {
    bullets,
    channel,
    description,
    documents,
    hideRichContents,
    highlights,
    itemId,
    modelNumber,
    rentalCategory,
    rentalSubCategory,
    returnMessage,
    showReturnMessage,
    showRichContentsOnly,
    showUpcCode,
    storeSkuNumber,
    upc,
  } = props;

  return (
    <Col className="mobile-content-wrapper">
      <Row>{highlights}</Row>
      {(modelNumber || storeSkuNumber || itemId || rentalCategory || rentalSubCategory) && (
        <Row className="card-mobile-row">
          { modelNumber && <ProductInfo title="Model" info={modelNumber} /> }
          { storeSkuNumber && <ProductInfo title="Sku" info={storeSkuNumber} /> }
          { itemId && <ProductInfo title="Internet" info={itemId} /> }
          { showUpcCode && upc && <ProductInfo title="UPC" info={upc} /> }
          { rentalCategory && rentalSubCategory && (
            <>
              <ProductInfo title="Rental Category" info={rentalCategory} />
              <ProductInfo title="Rental Subcategory" info={rentalSubCategory} />
            </>
          )}
        </Row>
      )}
      <Row className="main-description card-mobile-row">
        <p className="main-description--mobile">{description}</p>
        <BulletList
          bullets={bullets}
          margin
          isMobile
          showRichContentsOnly={showRichContentsOnly}
          hideRichContents={hideRichContents}
        />
        {documents && (
          <InfoGuides
            documents={documents}
            channel={channel}
            returnMessage={returnMessage}
            showReturnMessage={showReturnMessage}
          />
        )}
      </Row>
    </Col>
  );
};

MobileContent.displayName = 'MobileContent';

MobileContent.propTypes = {
  bullets: arrayOf(shape({})).isRequired,
  channel: string.isRequired,
  description: string.isRequired,
  documents: arrayOf(shape({
    name: string.isRequired,
    url: string.isRequired
  })).isRequired,
  hideRichContents: bool,
  highlights: node.isRequired,
  itemId: string.isRequired,
  modelNumber: string,
  rentalCategory: string,
  rentalSubCategory: string,
  returnMessage: string,
  showReturnMessage: bool,
  showRichContentsOnly: bool,
  showUpcCode: bool,
  storeSkuNumber: string,
  upc: string
};

MobileContent.defaultProps = {
  hideRichContents: false,
  modelNumber: '',
  rentalCategory: '',
  rentalSubCategory: '',
  returnMessage: '',
  showReturnMessage: false,
  showRichContentsOnly: false,
  showUpcCode: false,
  storeSkuNumber: '',
  upc: ''
};
